import LocationFormStepper from "@/components/forms/location/LocationFormStepper"
import { Scoped } from "@/components/forms/location/StepperDefinition"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useLocationCreateStore } from "@/stores/useLocationCreateStore"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/locaties/aanmaken/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "locations"),
})

function RouteComponent() {
  const { info, classrooms } = useLocationCreateStore()

  const initialStep = () => {
    if (!info) {
      return "info"
    } else if (!classrooms || classrooms.length === 0) {
      return "classrooms"
    }

    return "dossier"
  }

  return (
    <ScreenWrapper className="mt-8" showManagementMenu>
      <div className="flex w-full">
        <div className="flex flex-col justify-center h-full w-full">
          <h1>Nieuwe locatie</h1>
          <Scoped initialStep={initialStep()}>
            <LocationFormStepper />
          </Scoped>
        </div>
      </div>
    </ScreenWrapper>
  )
}
